module.exports = __webpack_public_path__ + "static/media/img-talent-profile-cards@3x.44d95c0b.png";